import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Card } from '@/components/sections/Card';
import { FunctionComponent } from 'react';
import guideImage1 from '../../../assets/stock-calculator-user-guide-pt1.png';
import guideImage2 from '../../../assets/stock-calculator-user-guide-pt2.png';

interface StockCalculatorUserGuideProps {}

const StockCalculatorUserGuide: FunctionComponent<StockCalculatorUserGuideProps> = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Stock Calculator User Guide',
      to: ''
    }
  ];

  return (
    <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title="Stock Calculator User Guide" breadcrumbs={breadcrumbs} />
      <div className="px-6 py-8 h-full text-lg overflow-y-auto">
        <Card className="p-5 space-y-5">
          <div className="space-y-1">
            <p>
              This is where you set the levels of inventory you wish to hold. We need two values for each
              device/peripheral. A 'minimum' and a 'maximum'. This allows DaaS Portal to automatically maintain stock
              levels for you. As you 'provision stock' to users in your organisation and the minimum stock level is
              reached, we will automatically order more to product to replenish to the 'maximum'.
            </p>

            <p>
              This gives you peace of mind stock is always on hand for a next day delivery, whilst allowing you to
              control the amount of stock you have, to avoid having too much inventory.
            </p>

            <p className="text-xl font-semibold pt-1">Bundle Stock Parameters</p>

            <p>
              Getting your stock levels just right is important. This part of the portal takes you through the process
              of setting up your stock levels and offers recommendations whilst also allowing you to edit and configure
              them as you wish, to meet your specific needs.
            </p>

            <p>Complete the highlighted (with a red dot) fields below:</p>

            <div
              className="rounded-mdp-0.5 !bg-contain !bg-no-repeat h-[200px] w-full"
              style={{
                background: `url(${guideImage1})`
              }}
            />

            <p>Providing you have created some bundles already, you will see them on this page also.</p>

            <p>Example:</p>
            <div
              className="rounded-mdp-0.5 !bg-contain !bg-no-repeat h-[200px] w-full"
              style={{
                background: `url(${guideImage2})`
              }}
            />

            <p>
              Complete these fields. In the above example, there are 200 employees, and the weighting in Sales is 25%
              which means you have 50 sales employees.
            </p>

            <p>Weightings must add up to 100% in total, or an error message will show.</p>

            <p className="pt-2">
              Now continue to 'Bundle Stock Levels' where you will see the recommended stock levels and can edit them as
              you wish.
            </p>

            <p className="text-xl font-semibold">Bundle Stock Levels</p>

            <p>
              <span className="font-semibold">NOTE:</span> You are not setting stock levels for your bundles, rather for
              the 'bill of materials' which make up your bundles.
            </p>

            <p>
              Based on your previous inputs, DaaS Portal gives you recommendations, but you can edit these to suit your
              organisation's needs.
            </p>

            <p className="text-xl font-semibold pt-1">Additional Stock Levels</p>

            <p>
              Set inventory levels for equipment outside of your defined bundles. This is typically for peripherals you
              want available for next-day delivery to handle scenarios such as:
            </p>

            <p>Replacing a faulty peripheral outside of warranty</p>

            <p>Fulfilling user requests for additional equipment (e.g. an extra monitor for a home office)</p>

            <p className="text-xl font-semibold pt-1">Stock Summary</p>

            <p>
              This is the summary page where your outputs are summarised and at this point you are ready to 'Begin
              Fulfillment'.
            </p>

            <p>
              Clicking the 'Begin Fulfillment' button is a legally binding order and instructs DaaS Portal to order
              stock and make these available to you inline with the service deliverables of the platform.
            </p>

            <p>If you wish to edit any of these values, this can be done in:</p>

            <p>"Bundle Stock Levels" and "Additional Stock Levels".</p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default StockCalculatorUserGuide;
